"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileRef = exports.FileType = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
var FileType;
(function (FileType) {
    FileType["pdf"] = "pdf";
    FileType["kette"] = "kette";
    FileType["innenaufteilung"] = "innenaufteilung";
})(FileType = exports.FileType || (exports.FileType = {}));
const fileRefValidation = {
    Id: true,
    Type: true,
};
/**
 * The `FileRef` defines a reference to a persisted file
 *
 * The reference is usually used to create an REST API call by igus Integration Framework in order
 * to download a file like an IA-Zeichnung
 */
class FileRef {
    static isFileRefModel(jsonOrModel) {
        return echain_shared_modelling_1.UseableUtil.validate(jsonOrModel, fileRefValidation);
    }
    get id() {
        return this.model.Id;
    }
    set id(v) {
        this.model.Id = v;
    }
    get type() {
        return this.model.Type;
    }
    set type(v) {
        this.model.Type = v;
    }
    get url() {
        return this.model.Url;
    }
    set url(v) {
        this.model.Url = v;
    }
    constructor(model) {
        this.model = model;
    }
    static fromJson(model) {
        return new FileRef((0, echain_shared_ts_utils_1.clonePrimitive)(model));
    }
    static fromModel(model) {
        return new FileRef(model);
    }
    fromJson(json) {
        if (json.Id != null)
            this.id = json.Id;
        if (json.Type != null)
            this.type = json.Type;
        if (json.Url && json.Url != null)
            this.url = json.Url;
    }
    fromModel(model) {
        this.model = model;
    }
    toJson() {
        return this.url ? { Id: this.id, Type: this.type, Url: this.url } : { Id: this.id, Type: this.type };
    }
    toModel() {
        return this.model;
    }
    clone() {
        return FileRef.fromJson(this.model);
    }
}
exports.FileRef = FileRef;
//# sourceMappingURL=FileRef.js.map